import { kubernetesPaths } from './paths';

// Plain data: no console, no loader (the entry chunk reads it; route.ts stays lazy).
/** Provider scopes this module serves in the service catalog (v1 console; v2 is tenant-scoped, no service id). */
export const serviceScopes = [
  { scope: 'Internal.Opennebula.Kubernetes', category: 'kubernetes', route: (id: string) => `${kubernetesPaths.base}/${id}` },
] as const;
